export default __webpack_public_path__ + "static/media/logo.f6179d4f.gif";